import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SupportDialog } from "@/components/shared/SupportDialog";
interface ProfileHeaderProps {
  avatarUrl?: string | null;
}
export const ProfileHeader = ({
  avatarUrl
}: ProfileHeaderProps) => {
  const navigate = useNavigate();
  return <div className="mb-8">
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-2xl font-bold">Your Profile</h2>
        <SupportDialog />
      </div>
    </div>;
};